<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="elevation-12 pa-6">
          <v-card-text class="text-center">
            <v-icon size="100" color="grey">mdi-alert-circle-outline</v-icon>
            <h1 class="text-h3 mt-4 mb-2">404</h1>
            <h2 class="text-h5 mb-4">Page Not Found</h2>
            <p class="text-body-1 mb-6">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <v-btn color="primary" @click="goHome" large> Go to Home </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/tourist')
    },
  },
}
</script>
